export default __webpack_public_path__ + "static/media/DiffOC&CC.48464d9f.png";